export const defaultProperties = {
  theme: 'light',
  placement: 'bottom',
  autoPlacement: true,
  alignToCenter: true,
  overlayBackdrop: false,
  maxWidth: '300px',
  height: 'auto',
  offset: 8,
  animationDuration: 100,
  animationTimingFunction: 'ease-in-out',
  animationTranslateY: '10px',
  zIndex: 1000,
  hideDelay: 100,
  showDelay: 300,
  trigger: 'click',
  display: true,
  isMobile: false,
  closeOnScroll: false,
  closeOnRotate: false,
};
